import React from "react";
import Navbar from "../Common/Navbar";
import HeroSection from "./HeroSection";
import PromoBanner from "./PromoBanner";
import DomainCategories from "./DomainCategories";
import WhyChooseUs from "./WhyChooseUs";
import TestimonialsSection from "./TestimonialsSection";
import HeroTop from "./HomeTop";
import Footer from "./Footer";
import GrowthControlSection from "./GrowthControlSection";
import BusinessEmailSectionPro from "./BusinessEmailSectionPro";
import WebsiteBuilderSection from "./WebsiteBuilderSection";
import BusinessStartSection from "./BusinessStartSection";
import DomainStepsSection from "./DomainStepsSection";
import PricingCards from "./PricingCards";


const Home = () => {
  return (
    <>
      <Navbar />
      <HeroTop/>
      <HeroSection />
      <PromoBanner />
      <DomainCategories />
<WebsiteBuilderSection/>
<PricingCards/>
      <GrowthControlSection/>
      <BusinessEmailSectionPro/>
      <BusinessStartSection/>
      <DomainStepsSection/>
      <WhyChooseUs />
      <TestimonialsSection />
      <Footer />
    </>
  );
};

export default Home;